module.exports = __webpack_public_path__ + "static/media/coding.9abb2ad4.svg";